import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IndicadorService } from '../indicador.service';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { Indicador } from '../../comum/modelos/indicador';
import { IndicadorProcesso } from '../../comum/modelos/indicador-processo';
import { IndicadorRotina } from '../../comum/modelos/indicador-rotina';
import { IndicadorSetor } from '../../comum/modelos/indicador-setor';
import { PontoFisico } from '../../comum/modelos/ponto-fisico';
import { ProcessoSetor } from '../../comum/modelos/processo-setor';
import { RotinaProcesso } from '../../comum/modelos/rotina-processo';
import { SetorPontoFisico } from '../../comum/modelos/setor-ponto-fisico';
import { PontoFisicoService } from '../../ponto-fisico/ponto-fisico.service';
import { ProcessoService } from '../../processo/processo.service';
import { RotinaService } from '../../rotina/rotina.service';
import { SetorService } from '../../setor/setor.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Setor } from '../../comum/modelos/setor';
import { Processo } from '../../comum/modelos/processo';
import { RotinaCliente } from '../../comum/modelos/rotina-cliente';
import { SelectItem, ConfirmationService } from 'primeng/primeng';
import { CriticidadeRotina } from '../../comum/modelos/criticidade-rotina';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-cadastro-indicador',
  templateUrl: './cadastro-indicador.component.html',
  styleUrls: ['./cadastro-indicador.component.css']
})
export class CadastroIndicadorComponent implements OnInit {

  indicador: Indicador;
  setoresPontoFisico: SetorPontoFisico[];
  setores: Setor[];
  processosSetor: ProcessoSetor[];
  processos: Processo[];
  rotinasProcesso: RotinaProcesso[];
  rotinasCliente: RotinaCliente[];
  pontosFisicos: PontoFisico[];
  indicadoresSetor: IndicadorSetor[];
  indicadoresProcesso: IndicadorProcesso[];
  indicadoresRotina: IndicadorRotina[];
  criticidades: CriticidadeRotina[];
  setoresSelectItem: SelectItem[];
  processosSelectItem: SelectItem[];
  rotinasSelectItem: SelectItem[];
  criticidadesSelectItem: SelectItem[];
  metas: SelectItem[];
  idsSetoresSelecionados: number[] = [];
  idsProcessosSelecionados: number[] = [];
  idsRotinasSelecionados: number[] = [];
  idsCriticidadesSelecionados: number[] = [];
  selecione = 'Selecione';
  numeroSetores: number;
  numeroProcessos: number;
  numeroRotinas: number;

  MODO: string;
  CADASTRAR = 'Cadastrar';
  ATUALIZAR = 'Atualizar';
  statusCode: number;

  public evento: Evento;

  public loading = false;

  constructor(
    private _indicadorService: IndicadorService,
    private _pontoFisicoService: PontoFisicoService,
    private _setorService: SetorService,
    private _processoService: ProcessoService,
    private _rotinaService: RotinaService,
    private _comumService: ComumService,
    private _activatedRoute: ActivatedRoute,
    private router: Router,
    private confirmationService: ConfirmationService,
    private _cookieService: CookieService,
    private _authService: AuthService) {
    this.setoresPontoFisico = new Array<SetorPontoFisico>();
    this.setores = new Array<Setor>();
    this.processosSetor = new Array<ProcessoSetor>();
    this.processos = new Array<Processo>();
    this.rotinasProcesso = new Array<RotinaProcesso>();
    this.rotinasCliente = new Array<RotinaCliente>();
    this.pontosFisicos = new Array<PontoFisico>();
    this.indicadoresSetor = new Array<IndicadorSetor>();
    this.indicadoresProcesso = new Array<IndicadorProcesso>();
    this.indicadoresRotina = new Array<IndicadorRotina>();
    this.criticidades = new Array<CriticidadeRotina>();
    this.setoresSelectItem = new Array<SelectItem>();
    this.processosSelectItem = new Array<SelectItem>();
    this.rotinasSelectItem = new Array<SelectItem>();
    this.metas = new Array<SelectItem>();
    this.criticidadesSelectItem = new Array<SelectItem>();
    this.indicador = new Indicador();
    this.evento = this._comumService.evento;
  }

  ngOnInit() {
    this.loading = true;
    const id = this._activatedRoute.snapshot.params['id'];
    const idCliente = parseInt(this._cookieService.get('idCliente'), 10);
    const self = this;
    this.metas.push({
      label: '10%', value: 10
    }, {
      label: '20%', value: 20
    }, {
      label: '30%', value: 30
    }, {
      label: '40%', value: 40
    }, {
      label: '50%', value: 50
    }, {
      label: '60%', value: 60
    }, {
      label: '70%', value: 70
    }, {
      label: '80%', value: 80
    }, {
      label: '90%', value: 90
    }, {
      label: '100%', value: 100
    });
    if (id !== undefined) {
      forkJoin(
        this._indicadorService.obterIndicadorPorIdHttp(id),
        this._indicadorService.obterIndicadoresSetorHttp(id),
        this._indicadorService.obterIndicadoresProcessoHttp(id),
        this._indicadorService.obterIndicadoresRotinaHttp(id),
        this._pontoFisicoService.obterPontosFisicoClienteHttp(idCliente),
        this._rotinaService.obterCriticidadesRotinaHttp())
        .subscribe(([indicador, indicadoresSetor, indicadoresProcesso, indicadoresRotina, pontosFisicos, criticidades]) => {
          self.indicador = indicador;
          self.indicadoresSetor = indicadoresSetor;
          self.indicadoresProcesso = indicadoresProcesso;
          self.indicadoresRotina = indicadoresRotina;
          self.pontosFisicos = pontosFisicos;
          self.criticidades = criticidades;
          self.criticidades.forEach(criticidade => {
            self.criticidadesSelectItem.push({
              label: criticidade.descricaoCriticidade, value: criticidade.idCriticidadeRotina
            });
          });

          self.loading = true;
          self.setoresSelectItem = [];
          self._setorService.obterSetoresFromPontosFisicosHttp(pontosFisicos)
            .subscribe((setores) => {
              self.setores = setores;
              self.numeroSetores = setores.length;
              self.setores.forEach(setor => {
                self.setoresSelectItem.push({
                  label: setor.nomeSetor, value: setor.idSetor
                });
              });

              self._setorService.obterSetoresPontosFisicosHttp(pontosFisicos)
                .subscribe(setoresPontoFisico => {
                  const setoresPontoFisicoSelecionados = new Array<SetorPontoFisico>();
                  for (const setorPontoFisico of setoresPontoFisico) {
                    for (const indicadorSetor of indicadoresSetor) {
                      if (setorPontoFisico.idSetorPontoFisico === indicadorSetor.idSetorPontoFisico) {
                        setoresPontoFisicoSelecionados.push(setorPontoFisico);
                        self.idsSetoresSelecionados.push(setorPontoFisico.setor.idSetor);
                        break;
                      }
                    }
                    self.setoresPontoFisico.push(setorPontoFisico);
                  }

                  self.processosSelectItem = [];
                  self._processoService.obterProcessosFromSetoresPontoFisicoHttp(setoresPontoFisicoSelecionados)
                    .subscribe((processos) => {
                      self.processos = processos;
                      self.numeroProcessos = processos.length;
                      self.processos.forEach(processo => {
                        self.processosSelectItem.push({
                          label: processo.nomeProcesso, value: processo.idProcesso
                        });
                      });

                      self._processoService.obterProcessosSetoresHttp(setoresPontoFisicoSelecionados)
                        .subscribe((processosSetor: ProcessoSetor[]) => {
                          const processosSetoresSelecionados = new Array<ProcessoSetor>();
                          for (const processoSetor of processosSetor) {
                            for (const indicadorProcesso of indicadoresProcesso) {
                              if (processoSetor.idProcessoSetor === indicadorProcesso.idProcessoSetor) {
                                processosSetoresSelecionados.push(processoSetor);
                                self.idsProcessosSelecionados.push(processoSetor.processo.idProcesso);
                                break;
                              }
                            }
                            self.processosSetor.push(processoSetor);
                          }

                          self._rotinaService.obterRotinasClienteFromProcessosSetorHttp(processosSetoresSelecionados)
                            .subscribe((rotinasCliente) => {
                              self.rotinasCliente = rotinasCliente;
                              self.numeroRotinas = rotinasCliente.length;
                              self.rotinasCliente.forEach(rotina => {
                                self.rotinasSelectItem.push({ label: rotina.descricaoRotina, value: rotina.idRotinaCliente });
                              });

                              self._rotinaService.obterRotinasProcessosHttp(processosSetoresSelecionados)
                                .subscribe((rotinasProcesso: RotinaProcesso[]) => {
                                  const rotinasProcessoSelecionadas = new Array<RotinaProcesso>();
                                  for (const rotinaProcesso of rotinasProcesso) {
                                    for (const indicadorRotina of indicadoresRotina) {
                                      if (rotinaProcesso.idRotinaProcesso === indicadorRotina.idRotinaProcesso) {
                                        rotinasProcessoSelecionadas.push(rotinaProcesso);
                                        self.idsRotinasSelecionados.push(rotinaProcesso.rotinaCliente.idRotinaCliente);
                                        break;
                                      }
                                    }
                                    self.rotinasProcesso.push(rotinaProcesso);
                                    self.loading = false;
                                    self.MODO = self.ATUALIZAR;
                                  }
                                });
                            });
                        });
                    });
                });
            });
        });
    } else {
      this.indicador.idCliente = idCliente;
      forkJoin(this._pontoFisicoService.obterPontosFisicoClienteHttp(idCliente),
        this._rotinaService.obterCriticidadesRotinaHttp())
        .subscribe(([pontosFisicos, criticidades]) => {
          this.criticidades = criticidades;
          this.criticidades.forEach(criticidade => {
            this.criticidadesSelectItem.push({
              label: criticidade.descricaoCriticidade, value: criticidade.idCriticidadeRotina
            });
          });
          this.pontosFisicos = pontosFisicos;
          this._setorService.obterSetoresFromPontosFisicosHttp(pontosFisicos)
            .subscribe((setores) => {
              self.setores = setores;
              self.setores.forEach(setor => {
                self.setoresSelectItem.push({
                  label: setor.nomeSetor, value: setor.idSetor
                });
              });
              self._setorService.obterSetoresPontosFisicosHttp(pontosFisicos)
                .subscribe(setoresPontoFisico => {
                  self.setoresPontoFisico = setoresPontoFisico;
                  self.MODO = self.CADASTRAR;
                  self.loading = false;
                });
            });
        });
    }
  }

  selecionarProcessos(idsSetor: number[]): void {
    this.loading = true;
    this.idsSetoresSelecionados = idsSetor;
    this.processosSelectItem = [];
    this.idsProcessosSelecionados = [];
    this.idsRotinasSelecionados = [];
    this.rotinasSelectItem = [];
    this.indicador.notaMaximaIndicador = 0;
    this.numeroSetores = idsSetor.length;
    const listaSetor = new Array<SetorPontoFisico>();
    this.setoresPontoFisico.forEach(setorPontoFisico => {
      if (idsSetor.find(idSetor => idSetor === setorPontoFisico.setor.idSetor)) {
        listaSetor.push(setorPontoFisico);
      }
    });
    if (idsSetor.length > 0) {
      this._processoService.obterProcessosFromSetoresPontoFisicoHttp(listaSetor)
        .subscribe((processos) => {
          this.processos = processos;
          this.processos.forEach(processo => {
            this.processosSelectItem.push({
              label: processo.nomeProcesso, value: processo.idProcesso
            });
          });
          this._processoService.obterProcessosSetoresHttp(listaSetor)
            .subscribe((processosSetor: ProcessoSetor[]) => {
              processosSetor.forEach(processoSetor => {
                this.processosSetor.push(processoSetor);
              });
              this.loading = false;
            });
        });
    } else {
      this.loading = false;
    }
  }

  selecionarRotinas(idsProcesso: number[]): void {
    this.loading = true;
    this.idsProcessosSelecionados = idsProcesso;
    this.idsRotinasSelecionados = [];
    this.rotinasSelectItem = [];
    this.indicador.notaMaximaIndicador = 0;
    const listaProcessos = new Array<ProcessoSetor>();
    this.numeroProcessos = idsProcesso.length;
    if (idsProcesso.length > 0) {
      this.processosSetor.forEach(processoSetor => {
        if (idsProcesso.find(idProcesso => idProcesso === processoSetor.processo.idProcesso)) {
          listaProcessos.push(processoSetor);
        }
      });

      this._rotinaService.obterRotinasProcessosHttp(listaProcessos)
        .subscribe((rotinasProcesso: RotinaProcesso[]) => {
          this.rotinasProcesso = rotinasProcesso;
          this._rotinaService.obterRotinasClienteFromProcessosSetorHttp(listaProcessos)
            .subscribe((rotinasCliente) => {
              rotinasCliente.forEach(rotinaCliente => {
                if (this.idsCriticidadesSelecionados.length > 0) {
                  if (this.idsCriticidadesSelecionados.find(criticidade => criticidade
                    === rotinaCliente.criticidadeRotina.idCriticidadeRotina)) {
                    this.rotinasCliente.push(rotinaCliente);
                  }
                } else {
                  this.rotinasCliente.push(rotinaCliente);
                }
              });
              this.rotinasCliente.forEach(rotina => {
                this.rotinasSelectItem.push({ label: rotina.descricaoRotina, value: rotina.idRotinaCliente });
              });
              this.loading = false;
            });
        });
    } else {
      this.loading = false;
    }
  }

  filtrarRotinasCriticidade(idsCriticidade: number[]): void {
    this.idsCriticidadesSelecionados = idsCriticidade;
    this.idsRotinasSelecionados = [];
    if (this.rotinasCliente.length > 0) {
      if (this.idsCriticidadesSelecionados.length > 0) {
        const listaProcessos = new Array<ProcessoSetor>();
        this.rotinasSelectItem = new Array<SelectItem>();
        this.rotinasCliente = new Array<RotinaCliente>();
        if (this.idsProcessosSelecionados.length > 0) {
          this.processosSetor.forEach(processoSetor => {
            if (this.idsProcessosSelecionados.find(idProcesso => idProcesso === processoSetor.processo.idProcesso)) {
              listaProcessos.push(processoSetor);
            }
          });

          this._rotinaService.obterRotinasProcessosHttp(listaProcessos)
            .subscribe((rotinasProcesso: RotinaProcesso[]) => {
              this.rotinasProcesso = rotinasProcesso;
              this._rotinaService.obterRotinasClienteFromProcessosSetorHttp(listaProcessos)
                .subscribe((rotinasCliente) => {
                  rotinasCliente.forEach(rotinaCliente => {
                    if (this.idsCriticidadesSelecionados.length > 0) {
                      if (this.idsCriticidadesSelecionados.find(criticidade => criticidade
                        === rotinaCliente.criticidadeRotina.idCriticidadeRotina)) {
                        this.rotinasCliente.push(rotinaCliente);
                      }
                    } else {
                      this.rotinasCliente.push(rotinaCliente);
                    }
                  });
                  this.rotinasCliente.forEach(rotina => {
                    this.rotinasSelectItem.push({ label: rotina.descricaoRotina, value: rotina.idRotinaCliente });
                    this.idsRotinasSelecionados.push(rotina.idRotinaCliente);
                  });
                  this.loading = false;
                });
            });
        } else {
          this.loading = false;
        }
      }
    }
  }

  calcularNotaMaximaIndicador(idsRotina: number[]): void {
    this.indicador.notaMaximaIndicador = 0;
    this.idsRotinasSelecionados = idsRotina;
    this.numeroRotinas = idsRotina.length;
    const idDistinct = new Set<number>();
    idsRotina.forEach(idRotina => {
      idDistinct.add(idRotina);
    });

    this.rotinasCliente.forEach(rotinaCliente => {
      if (idDistinct.has(rotinaCliente.idRotinaCliente)) {
        if (rotinaCliente.criticidadeRotina.descricaoCriticidade === 'Alto') {
          rotinaCliente.criteriosAvaliacaoRotina.forEach(criterio => {
            if (criterio.criterioAvaliacao.nomeCriterioAvaliacao === '\u00d3timo') {
              this.indicador.notaMaximaIndicador += (criterio.criterioAvaliacao.pesoCriterioAvaliacao * 2);
            }
          });
        } else {
          rotinaCliente.criteriosAvaliacaoRotina.forEach(criterio => {
            if (criterio.criterioAvaliacao.nomeCriterioAvaliacao === '\u00d3timo') {
              this.indicador.notaMaximaIndicador += criterio.criterioAvaliacao.pesoCriterioAvaliacao;
            }
          });
        }
      }
    });
  }

  onSubmit(): void {
    this.loading = true;
    const self = this;
    if (this.idsSetoresSelecionados.length > 0 && this.idsProcessosSelecionados.length > 0 && this.idsRotinasSelecionados.length > 0) {
      if (this.MODO === this.CADASTRAR) {
        this._indicadorService.cadastrarIndicadorHttp(this.indicador)
          .subscribe(response => {
            self.cadastrarIndicadoresSetor(response.body.idIndicador);
          }, errorCode => {
            self.statusCode = errorCode;
            self.loading = false;
          });
      } else {
        this._indicadorService.atualizarIndicadorHttp(this.indicador)
          .subscribe(response => {
            self.atualizarIndicadoresSetor();
            self.statusCode = response.status;
          }, errorCode => {
            self.statusCode = errorCode;
            self.loading = false;
          });
      }
    } else {
      self.loading = false;
      this.confirmationService.confirm({
        message: '\u00c9 necess\u00e1rio selecionar ao menos um setor, processo e checklist',
        rejectVisible: false,
        accept: () => {
        },
        reject: () => {
        }
      });
    }
  }

  cadastrarIndicadoresSetor(idIndicador: number): void {
    const indicadoresSetorInsert = new Array<IndicadorSetor>();
    this.setoresPontoFisico.forEach(setorPontoFisico => {
      if (this.idsSetoresSelecionados.find(setor => setor === setorPontoFisico.setor.idSetor)) {
        const indicadorSetor = new IndicadorSetor();
        indicadorSetor.idIndicador = idIndicador;
        indicadorSetor.idSetorPontoFisico = setorPontoFisico.idSetorPontoFisico;
        indicadoresSetorInsert.push(indicadorSetor);
      }
    });
    if (indicadoresSetorInsert.length > 0) {
      this._indicadorService.cadastrarIndicadoresSetorHttp(indicadoresSetorInsert)
        .subscribe(response => {
          this.statusCode = response.status;
          this.cadastrarIndicadoresProcesso(idIndicador);
        }, errorCode => {
          this.statusCode = errorCode;
        });
    }
  }

  cadastrarIndicadoresProcesso(idIndicador: number): void {
    const indicadoresProcessoInsert = new Array<IndicadorProcesso>();
    this.processosSetor.forEach(processoSetor => {
      if (this.idsProcessosSelecionados.find(processo => processo === processoSetor.processo.idProcesso)) {
        const indicadorProcesso = new IndicadorProcesso();
        indicadorProcesso.idIndicador = idIndicador;
        indicadorProcesso.idProcessoSetor = processoSetor.idProcessoSetor;
        indicadoresProcessoInsert.push(indicadorProcesso);
      }
    });
    if (indicadoresProcessoInsert.length > 0) {
      this._indicadorService.cadastrarIndicadoresProcessoHttp(indicadoresProcessoInsert)
        .subscribe(response => {
          this.cadastrarIndicadoresRotina(idIndicador);
          this.statusCode = response.status;
        }, errorCode => {
          this.statusCode = errorCode;
        });
    }
  }

  cadastrarIndicadoresRotina(idIndicador: number): void {
    const indicadoresRotinaInsert = new Array<IndicadorRotina>();
    this.rotinasProcesso.forEach(rotinaProcesso => {
      if (this.idsRotinasSelecionados.find(rotina => rotina === rotinaProcesso.rotinaCliente.idRotinaCliente)) {
        const indicadorRotina = new IndicadorRotina();
        indicadorRotina.idIndicador = idIndicador;
        indicadorRotina.idRotinaProcesso = rotinaProcesso.idRotinaProcesso;
        indicadoresRotinaInsert.push(indicadorRotina);
      }
    });
    if (indicadoresRotinaInsert.length > 0) {
      this._indicadorService.cadastrarIndicadoresRotinaHttp(indicadoresRotinaInsert)
        .subscribe(response => {
          this.statusCode = response.status;
          this.loading = false;
          this._comumService.evento.cadastro = true;
          this.router.navigate(['listar-indicadores']);
        }, errorCode => {
          this.statusCode = errorCode;
        });
    }
  }

  atualizarIndicadoresSetor(): void {
    const indicadoresSetorInsert = new Array<IndicadorSetor>();
    const indicadoresSetorRemove = new Array<IndicadorSetor>();
    const setIdsSetores = new Set<number>();
    this.idsSetoresSelecionados.forEach(idSetor => {
      setIdsSetores.add(idSetor);
    });

    const setIndicadoresSetor = new Set<number>();
    this.indicadoresSetor.forEach(indicadorSetor => {
      setIndicadoresSetor.add(indicadorSetor.idSetorPontoFisico);
    });

    this.setoresPontoFisico.forEach(setorPontoFisico => {
      if (setIdsSetores.has(setorPontoFisico.setor.idSetor)) {
        if (!setIndicadoresSetor.has(setorPontoFisico.idSetorPontoFisico)) {
          const indicadorSetor = new IndicadorSetor();
          indicadorSetor.idIndicador = this.indicador.idIndicador;
          indicadorSetor.idSetorPontoFisico = setorPontoFisico.idSetorPontoFisico;
          indicadoresSetorInsert.push(indicadorSetor);
        }
      } else if (setIndicadoresSetor.has(setorPontoFisico.idSetorPontoFisico)) {
        this.indicadoresSetor.forEach(indicadorSetor => {
          if (indicadorSetor.idSetorPontoFisico === setorPontoFisico.idSetorPontoFisico) {
            indicadoresSetorRemove.push(indicadorSetor);
          }
        });
      }
    });

    if (indicadoresSetorInsert.length > 0) {
      this._indicadorService.cadastrarIndicadoresSetorHttp(indicadoresSetorInsert)
        .subscribe(response => {
          this.statusCode = response.status;
        }, errorCode => {
          this.statusCode = errorCode;
        });
    }

    if (indicadoresSetorRemove.length > 0) {
      this._indicadorService.removerIndicadoresSetorHttp(indicadoresSetorRemove)
        .subscribe(response => {
          this.statusCode = response.status;
        }, errorCode => {
          this.statusCode = errorCode;
        });
    }
    this.atualizarIndicadoresProcesso();
  }

  atualizarIndicadoresProcesso(): void {
    const indicadoresProcessoInsert = new Array<IndicadorProcesso>();
    const indicadoresProcessoRemove = new Array<IndicadorProcesso>();
    const setIdsProcessos = new Set<number>();
    this.idsProcessosSelecionados.forEach(idProcesso => {
      setIdsProcessos.add(idProcesso);
    });

    const setIndicadoresProcesso = new Set<number>();
    this.indicadoresProcesso.forEach(indicadorProcesso => {
      setIndicadoresProcesso.add(indicadorProcesso.idProcessoSetor);
    });

    this.processosSetor.forEach(processoSetor => {
      if (setIdsProcessos.has(processoSetor.processo.idProcesso)) {
        if (!setIndicadoresProcesso.has(processoSetor.idProcessoSetor)) {
          const indicadorProcesso = new IndicadorProcesso();
          indicadorProcesso.idIndicador = this.indicador.idIndicador;
          indicadorProcesso.idProcessoSetor = processoSetor.idProcessoSetor;
          indicadoresProcessoInsert.push(indicadorProcesso);
        }
      } else if (setIndicadoresProcesso.has(processoSetor.idProcessoSetor)) {
        this.indicadoresProcesso.forEach(indicadorProcesso => {
          if (indicadorProcesso.idProcessoSetor === processoSetor.idProcessoSetor) {
            indicadoresProcessoRemove.push(indicadorProcesso);
          }
        });
      }
    });

    if (indicadoresProcessoInsert.length > 0) {
      this._indicadorService.cadastrarIndicadoresProcessoHttp(indicadoresProcessoInsert)
        .subscribe(response => {
          this.statusCode = response.status;
        }, errorCode => {
          this.statusCode = errorCode;
        });
    }

    if (indicadoresProcessoRemove.length > 0) {
      this._indicadorService.removerIndicadoresProcessoHttp(indicadoresProcessoRemove)
        .subscribe(response => {
          this.statusCode = response.status;
        }, errorCode => {
          this.statusCode = errorCode;
        });
    }
    this.atualizarIndicadoresRotina();
  }

  atualizarIndicadoresRotina(): void {
    const indicadoresRotinaInsert = new Array<IndicadorRotina>();
    const indicadoresRotinaRemove = new Array<IndicadorRotina>();
    const setIdsRotina = new Set<number>();
    this.idsRotinasSelecionados.forEach(idRotina => {
      setIdsRotina.add(idRotina);
    });

    const setIndicadoresRotina = new Set<number>();
    this.indicadoresRotina.forEach(indicadorRotina => {
      setIndicadoresRotina.add(indicadorRotina.idRotinaProcesso);
    });

    this.rotinasProcesso.forEach(rotinaProcesso => {
      if (setIdsRotina.has(rotinaProcesso.rotinaCliente.idRotinaCliente)) {
        if (!setIndicadoresRotina.has(rotinaProcesso.idRotinaProcesso)) {
          const indicadorRotina = new IndicadorRotina();
          indicadorRotina.idIndicador = this.indicador.idIndicador;
          indicadorRotina.idRotinaProcesso = rotinaProcesso.idRotinaProcesso;
          indicadoresRotinaInsert.push(indicadorRotina);
        }
      } else if (setIndicadoresRotina.has(rotinaProcesso.idRotinaProcesso)) {
        this.indicadoresRotina.forEach(indicadorRotina => {
          if (indicadorRotina.idRotinaProcesso === rotinaProcesso.idRotinaProcesso) {
            indicadoresRotinaRemove.push(indicadorRotina);
          }
        });
      }
    });

    if (indicadoresRotinaInsert.length > 0) {
      this._indicadorService.cadastrarIndicadoresRotinaHttp(indicadoresRotinaInsert)
        .subscribe(response => {
          this.statusCode = response.status;
        }, errorCode => {
          this.statusCode = errorCode;
        });
    }

    if (indicadoresRotinaRemove.length > 0) {
      this._indicadorService.removerIndicadoresRotinaHttp(indicadoresRotinaRemove)
        .subscribe(response => {
          this.statusCode = response.status;
        }, errorCode => {
          this.statusCode = errorCode;
        });
    }
    this.loading = false;
    this._comumService.evento.atualizar = true;
    this.router.navigate(['listar-indicadores']);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/indicador/cadastro-indicador/cadastro-indicador.component.ts